{
  "list": {
    "title": "Customers",
    "subtitle": "Manage customers (parents / self-paying students).",
    "add": "Add Client",
    "search": "Search clients (name, email, phone, tag)...",
    "filterByTag": "Filter by tag",
    "clearFilter": "Clear filter",
    "noResults": "No matching clients found.",
    "name": "Name",
    "email": "Email",
    "zaloPhone": "Zalo / Phone",
    "added": "Added",
    "outstanding": "Outstanding",
    "actions": "Actions",
    "loading": "Loading...",
    "empty": "No clients found. Add your first client to get started.",
    "view": "View",
    "sortNewest": "Newest",
    "sortOldest": "Oldest",
    "sortName": "Name A→Z",
    "prev": "Previous",
    "next": "Next",
    "pageOf": "Page {{page}}/{{pages}} · {{total}} clients"
  },
  "create": {
    "title": "Add Client",
    "description": "Enter your client's details below. Name is required.",
    "name": "Name *",
    "namePlaceholder": "Acme Corp",
    "email": "Email",
    "emailPlaceholder": "contact@acme.com",
    "zaloPhone": "Zalo / Phone",
    "zaloPhonePlaceholder": "0901234567",
    "dupPayerWarning": "This phone already belongs to payer {{name}} — reuse it?",
    "cancel": "Cancel",
    "submit": "Save Client",
    "submitting": "Saving..."
  },
  "detail": {
    "notFound": "Customer not found",
    "backToList": "Back",
    "delete": "Delete customer",
    "deleteConfirm": "Are you sure you want to delete this customer? Their invoices will be kept.",
    "identityBadge": "Customer · parent",
    "createInvoice": "Create invoice",
    "edit": "Edit",
    "tabsLabel": "Customer sections",
    "added": "Added {{date}}",
    "phoneZalo": "{{phone}} (Zalo)",
    "emptyStudentsTitle": "No students yet",
    "emptyStudentsBody": "Add a student and pick {{name}} as the payer.",
    "emptyStudentsCta": "Add student",
    "tabs": {
      "students": "Students",
      "invoices": "Invoices",
      "notes": "Notes",
      "activity": "Activity",
      "info": "Info"
    },
    "stats": {
      "invoiceCount": "Invoices",
      "revenue": "Revenue",
      "unpaid": "Unpaid",
      "overdue": "Overdue"
    }
  },
  "tags": {
    "label": "Tags",
    "addTag": "Add tag",
    "addPlaceholder": "Tag name...",
    "moreCount": "+{{count}}"
  },
  "invoices": {
    "code": "Invoice",
    "amount": "Amount",
    "status": "Status",
    "due": "Due",
    "empty": "No invoices for this client yet",
    "createFirst": "Create invoice",
    "emptyBody": "Create a one-off invoice for this customer, or wait for Close-the-month to generate one."
  },
  "notes": {
    "addPlaceholder": "Add a note about this client...",
    "save": "Save",
    "saving": "Saving...",
    "edit": "Edit",
    "delete": "Delete",
    "cancel": "Cancel",
    "deleteConfirm": "Delete this note?",
    "showingRecent": "Showing 50 most recent notes",
    "emptyTitle": "No notes yet",
    "emptyBody": "Record tuition agreements, time off… so the whole org can see them."
  },
  "activity": {
    "invoiceCreated": "Created invoice {{code}} for {{amount}}",
    "invoiceSent": "Sent invoice {{code}} via email",
    "invoiceSentZalo": "Sent invoice {{code}} via Zalo",
    "invoicePaid": "Invoice {{code}} paid {{amount}}",
    "invoiceOverdue": "Invoice {{code}} is overdue",
    "invoiceCancelled": "Cancelled invoice {{code}}",
    "invoiceViewed": "Client viewed invoice {{code}}",
    "reminderSent": "Sent reminder for invoice {{code}}",
    "noteAdded": "Added note: \"{{preview}}\"",
    "noteEdited": "Edited a note",
    "tagAdded": "Added tag {{tag}}",
    "tagRemoved": "Removed tag {{tag}}",
    "infoUpdated": "Updated {{field}} from {{oldValue}} → {{newValue}}",
    "loadMore": "Load more",
    "loading": "Loading...",
    "empty": "No activity yet."
  },
  "fields": {
    "name": "name",
    "email": "email",
    "zaloPhone": "phone"
  },
  "info": {
    "title": "Customer information",
    "name": "Customer name",
    "email": "Email",
    "zaloPhone": "Zalo / Phone",
    "save": "Save changes",
    "saving": "Saving...",
    "cancel": "Cancel"
  }
}
